import React from 'react';
import '../../styles/CaseStudyOne/CaseStudiesResults.css';
import productIcon1 from '../../assets/money-down.png';
import productIcon2 from '../../assets/bullseye.png';
import productIcon3 from '../../assets/pink-star.png';

const CaseStudiesResults = () => {
  return (
    <section className="case-results-section">
      <div className="case-results-container">
        {/* Title */}
        <h2 className="case-results-title">The Results</h2>

        {/* Product/Service Boxes */}
        <div className="winning-item-container">
          <div className="winning-item-box">
            <img src={productIcon1} alt="Winning Item 1" className="winning-product-icon" />
            <p>Significant Cost Reduction</p>
          </div>
          <div className="winning-item-box">
            <img src={productIcon2} alt="Winning Item 2" className="winning-product-icon" />
            <p>Accurate Conversion Tracking</p>
          </div>
          <div className="winning-item-box">
            <img src={productIcon3} alt="Winning Item 3" className="winning-product-icon" />
            <p>PMAX Campaign Success</p>
          </div>
        </div>

        {/* Description Text */}
        <ul className="case-results-description">
          <li>Bullfrog’s cost per booked appointment decreased to a range of $74-$136 in 2024, a substantial improvement from the previous $200+ cost.</li>
          <li>ASKAI’s AI-driven data provided actionable insights, ensuring conversions reflected real booked appointments.</li>
          <li>Google PMAX campaigns became a viable strategy, driving high-quality calls and reducing spam.</li>
        </ul>

      </div>
    </section>
  );
};

export default CaseStudiesResults;